import { ChevronLeftIcon, Bars3Icon } from '@heroicons/react/24/outline';

export interface AppTopBarProps {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
  showMenu?: boolean;
  onMenuClick?: () => void;
  /** Ao lado do menu: o sino das notificações (19/10/2026). */
  direita?: React.ReactNode;
}

/**
 * Barra superior nativa (apenas no app Capacitor).
 * Renderizado pelo MainLayout quando Capacitor.isNativePlatform().
 */
export function AppTopBar({
  title,
  showBack = true,
  onBack,
  showMenu = false,
  onMenuClick,
  direita,
}: AppTopBarProps) {
  const handleBack = () => {
    if (onBack) onBack();
  };

  return (
    <header
      className="sticky top-0 z-50 flex items-center justify-between gap-2 bg-white shadow-sm min-h-[44px] px-2"
      style={{
        paddingTop: 'env(safe-area-inset-top, 0px)',
        paddingLeft: 'max(0.5rem, env(safe-area-inset-left))',
        paddingRight: 'max(0.5rem, env(safe-area-inset-right))',
      }}
    >
      <div className="flex min-w-0 flex-1 items-center">
        <div className="flex w-[44px] flex-shrink-0 items-center">
          {showBack && (
            <button
              type="button"
              onClick={handleBack}
              className="flex items-center gap-1 rounded-md p-2 text-gray-700 hover:bg-gray-100 min-h-[44px] min-w-[44px]"
              aria-label="Voltar"
            >
              <ChevronLeftIcon className="h-6 w-6 flex-shrink-0" />
              <span className="hidden sm:inline text-sm">Voltar</span>
            </button>
          )}
        </div>
        <h1 className="flex-1 min-w-0 truncate text-center text-lg font-semibold text-tinta px-1">
          {title}
        </h1>
        <div className="flex min-w-[44px] flex-shrink-0 items-center justify-end">
          {direita}
          {showMenu ? (
            <button
              type="button"
              onClick={onMenuClick}
              className="flex items-center justify-center rounded-md p-2 text-gray-600 hover:bg-gray-100 min-h-[44px] min-w-[44px]"
              aria-label="Abrir menu"
              data-testid="menu-da-barra-do-app"
            >
              <Bars3Icon className="h-6 w-6" />
            </button>
          ) : null}
        </div>
      </div>
    </header>
  );
}
